import { get } from 'lodash';
import env from '../config/env.json';

const getType = () => {
  let type = 'dev';
  if (process.env.REACT_APP_MODE === 'production') {
    type = 'prod';
  } else if (process.env.REACT_APP_MODE === 'staging') {
    type = 'staging';
  }

  return type;
};

export const getNetworkInfo = () => {
  const type = getType();
  const { network: { [type]: url, endpoints } } = env;
  return { ...url, endpoints };
};

export const getStripeInfo = currency => {
  return get(env, `stripe.${process.env.REACT_APP_MODE}.${currency}`);
};



// WEBPACK FOOTER //
// ./src/util/network.js